import React from "react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { DesktopCalendarView, formatWeekRange } from "./calendarUtils";

interface Props {
  view: DesktopCalendarView;
  selectedDate: Date;
  onViewChange: (view: DesktopCalendarView) => void;
  onNavigate: (direction: "prev" | "next") => void;
  onToday: () => void;
}

export default function CalendarToolbar({ view, selectedDate, onViewChange, onNavigate, onToday }: Props) {
  const label = view === "month"
    ? selectedDate.toLocaleDateString("en-GB", { month: "long", year: "numeric" })
    : formatWeekRange(selectedDate);

  return (
    <div className="calendar-toolbar">
      <div className="calendar-date-navigation">
        <button type="button" className="calendar-today-button" onClick={onToday}>Today</button>
        <button type="button" className="calendar-icon-button" onClick={() => onNavigate("prev")} aria-label={`Previous ${view === "month" ? "month" : "week"}`}><ChevronLeftIcon /></button>
        <strong>{label}</strong>
        <button type="button" className="calendar-icon-button" onClick={() => onNavigate("next")} aria-label={`Next ${view === "month" ? "month" : "week"}`}><ChevronRightIcon /></button>
      </div>
      <div className="calendar-view-switch" role="group" aria-label="Calendar view">
        {(["week", "month", "list"] as DesktopCalendarView[]).map((option) => (
          <button key={option} type="button" className={view === option ? "is-active" : ""} aria-pressed={view === option} onClick={() => onViewChange(option)}>{option[0].toUpperCase() + option.slice(1)}</button>
        ))}
      </div>
    </div>
  );
}
